import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "@/components/ui/input-otp";

export const InputOTP6 = (props: {
  onChange?: (value: string) => void;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  className?: string;
  required?: boolean;
}) => {
  return (
    <InputOTP
      maxLength={6}
      pattern="[a-zA-Z0-9]{0,6}"
      onPaste={(e) => {
        // Prevent pasting more than 6 characters
        const paste = e.clipboardData
          .getData("text")
          .replace(/[^a-zA-Z0-9]/gm, "")
          .slice(0, 6);
        e.preventDefault();
        document.execCommand("insertText", false, paste);
      }}
      {...props}
      onChange={(value) => {
        if (props.onChange) {
          props.onChange(value.replace(/[^a-zA-Z0-9]/gm, "").slice(0, 6));
        }
      }}
    >
      <InputOTPGroup>
        <InputOTPSlot index={0} className="capitalize" />
        <InputOTPSlot index={1} className="capitalize" />
        <InputOTPSlot index={2} className="capitalize" />
      </InputOTPGroup>
      <InputOTPSeparator />
      <InputOTPGroup>
        <InputOTPSlot index={3} className="capitalize" />
        <InputOTPSlot index={4} className="capitalize" />
        <InputOTPSlot index={5} className="capitalize" />
      </InputOTPGroup>
    </InputOTP>
  );
};
